var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('gmap-map',{staticStyle:{"width":"100%","height":"800px"},attrs:{"center":_vm.center,"zoom":_vm.zoom}},_vm._l((_vm.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.position,"title":marker.title}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }